export default __webpack_public_path__ + "static/media/sticker-D.6ef163e8.png";